import { ModalBody } from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives-next';
import Spinner from '@atlaskit/spinner';

export const RequestAssistanceModalLoader = () => {
	return (
		<ModalBody>
			<Box padding="space.200">
				<Spinner testId="spinner" interactionName="load" label="Loading" size="medium" />
			</Box>
		</ModalBody>
	);
};
